function validateSixDigitNumber(value: string): boolean {
  const regex = /^\d{0,6}$/;
  return regex.test(value);
}

export default validateSixDigitNumber;
